import type { ProductDetailPageTranslation } from "@swo/storefront";
import { createContext, useContext } from "react";
import type { Translated } from "../../domain/translations/translations";

const PdpTranslationsContext_ = createContext<Translated<ProductDetailPageTranslation> | undefined>(undefined);

export const PdpTranslationsContext = PdpTranslationsContext_.Provider;

export const usePdpTranslations = (): Translated<ProductDetailPageTranslation> => {
  const t = useContext(PdpTranslationsContext_);

  if (!t) {
    console.error("PdpTranslationsContext not found in", new Error().stack);

    return (token: string) => ({ value: token, key: undefined, type: "fallback" });
  }

  return t;
};
